import axios from "axios";

import endPoints from "../../../../../config/endPoints";

export const getAllServiceItems = async(reqBody) => {  
  return await axios.post(endPoints.serviceItems, reqBody);  
};
